<template>
  <div class="html-text-content-box">
    <div class="editor-text" v-html="showContent"></div>
  </div>
</template>

<script>
module.exports = {
  data() {
    return {
      showContent: ''
    };
  },
  props: {
    htmlcontent: [String]
  },
  mounted() {
    this.setShowContentInfo();
  },
  methods: {
    setShowContentInfo: function () {
      var contentInfo = this.htmlcontent;

      if (!contentInfo) {
        contentInfo = this.getTestData();
      }

      this.showContent = contentInfo;
      this.$forceUpdate();
    },
    getTestData: function () {
      var htmlContent = '<p>暂无内容</p>';
      return htmlContent;
    }
  },
  watch: {
    htmlcontent: function () {
      this.setShowContentInfo();
    }
  }
};
</script>
<style lang="less">
// @charset "UTF-8";

.editor-text {
  overflow: hidden;
  font-size: 0.16rem;
}

.editor-text p,
.editor-text div {
  width: 100%;
  word-break: normal;
  white-space: pre-wrap;
  white-space: pre-line;
  word-wrap: break-word;
  text-align: justify;
  font-size: 0.15rem;
  line-height: 28px;
  font-family: sans-serif;
  color: #333;
}

.editor-text strong,
.editor-text p strong {
  display: inline;
  font-weight: bold;
}

.editor-text span,
.editor-text p span {
  display: inline;
}

.editor-text em,
.editor-text p em {
  font-style: italic;
}

.editor-text,
.editor-text p {
  margin: auto;
  padding: auto;
}

.editor-text i,
.editor-text p i {
  font-style: italic;
}

.editor-text ol,
.editor-text ul {
  margin-left: 0;
  padding-left: 0.2rem;
  _margin-left: 0;
  _padding-left: 0.2rem;
}

/*有序的*/
.editor-text ol {
  list-style: decimal;
}

/*无序的*/
.editor-text ul {
  list-style: disc;
}

.editor-text ol ul,
.editor-text ul ol,
.editor-text ul ul,
.editor-text ol ol {
  margin-top: 0;
  margin-bottom: 0;
}

.editor-text img {
  display: block;
  width: 100% !important;
  height: auto !important;
  margin: 8px 0;
}

.editor-text pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.editor-text h1,
.editor-text h1 p,
.editor-text h1 span,
.editor-text h1 strong,
.editor-text h1 em,
.editor-text h1 i {
  font-size: 36px;
}

.editor-text h2,
.editor-text h2 p,
.editor-text h2 span,
.editor-text h2 strong,
.editor-text h2 em,
.editor-text h2 i {
  font-size: 32px;
}

.editor-text h3,
.editor-text h3 p,
.editor-text h3 span,
.editor-text h3 strong,
.editor-text h3 em,
.editor-text h3 i {
  font-size: 28px;
}

.editor-text h4,
.editor-text h4 p,
.editor-text h4 span,
.editor-text h4 strong,
.editor-text h4 em,
.editor-text h4 i {
  font-size: 24px;
}

.editor-text h5,
.editor-text h5 p,
.editor-text h5 span,
.editor-text h5 strong,
.editor-text h5 em,
.editor-text h5 i {
  font-size: 20px;
}

.editor-text h6,
.editor-text h6 p,
.editor-text h6 span,
.editor-text h6 strong,
.editor-text h6 em,
.editor-text h6 i {
  font-size: 16px;
}

.editor-text blockquote {
  font-size: 20px;
}

.editor-text strong {
  display: inline;
  font-weight: bold;
}

.editor-text em,
.editor-text i {
  display: inline;
  font-style: italic;
}

.editor-text em span,
.editor-text em strong,
.editor-text i span,
.editor-text i strong,
.editor-text em strong span,
.editor-text i strong span,
.editor-text em span strong,
.editor-text i span strong,
.editor-text i span span,
.editor-text i strong strong,
.editor-text em span span,
.editor-text em strong strong {
  font-style: italic;
}

.editor-text strong span,
.editor-text strong em,
.editor-text strong i,
.editor-text strong span span,
.editor-text strong em em,
.editor-text strong i i,
.editor-text strong span em,
.editor-text strong span i,
.editor-text strong i span,
.editor-text strong i em,
.editor-text strong em span,
.editor-text strong em i {
  font-weight: bold;
}

.editor-text pre,
/* .editor-text span,
.editor-text span span, */
.editor-text a

/* .editor-text div,
.editor-text strong,
.editor-text em,
.editor-text i,
.editor-text ol,
.editor-text ul,
.editor-text li,
.editor-text section,
.editor-text h1,
.editor-text h2,
.editor-text h3,
.editor-text h4,
.editor-text h5,
.editor-text h6,
.editor-text title,
.editor-text header */ {
  font-size: 16px !important;
  color: #666666;
  font-family: PingFangSC-Regular, PingFang SC;
  word-break: normal;
  white-space: pre-wrap;
  white-space: pre-line;
  word-wrap: break-word;
  text-align: justify;
}
</style>;



// WEBPACK FOOTER //
// src/components/basic/html_text_comp.vue